<template>
  <footer class="site-footer">
    <div class="content-max-width">
      <img src="/images/logo-small.png" alt="" class="mobile" />
      <div class="flex flex-between">
        <div class="flex links">
          <ul>
            <li><a href="/products">Products</a></li>
            <li><a href="/about">About 240 Connect</a></li>
            <li><a href="/customer-care">Customer Care</a></li>
          </ul>
          <ul>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/terms-conditions">Terms & Conditions</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
        <div class="subscribe">
          <img src="/images/logo-small.png" alt="" class="desktop" />

          <span v-if="successMessage" class="message success">{{
            successMessage
          }}</span>
          <div class="input-group">
            <input
              type="text"
              v-model="payload.email"
              placeholder="Enter email"
            />
            <button :disabled="isDisabled" @click="submitSubscription()">
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <div class="flex trustpilot-logo">
        <img src="/images/trustpilot.png" alt="" />
      </div>
      <div class="footer-legal">
        <p class="copyright">
          240 Connect &copy; {{ new Date().getFullYear() }} All rights reserved.
        </p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
          class="attribution"
          >Web design by Brownpaperbag.</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      payload: {
        email: ''
      },
      isDisabled: false,
      submissionErrors: [],
      successMessage: ''
    }
  },

  methods: {
    submitSubscription() {
      this.isDisabled = true
      this.successMessage = ''
      this.submissionErrors = []
      
      axios
        .post('/subscriber', this.payload)
        .then(res => {
          this.successMessage = "You've successfully subscribed"
          this.clear()
        })
        .catch(error => {
          this.submissionErrors = error.response.data.errors
          console.log(this.submissionErrors)
        })
        .then(res => {
          this.isDisabled = false
        })
    },

    clear() {
      this.payload.email = ''
    }
  }
}
</script>
<style scoped lang="scss">
.message.success {
  color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue